export const HOME_FAQS = [
  {
    q: "¿Cómo sé si Shipply es buen fit para mi operación?",
    a: "Suele ser buen fit cuando ya tienes pedidos recurrentes, varios canales de venta o errores operativos que te quitan foco comercial. En la primera conversación revisamos volumen, ciudad, tipo de producto y canales.",
  },
  {
    q: "¿Puedo conectar mi tienda online?",
    a: "Sí. Evaluamos Shopify, WooCommerce, marketplaces u otros sistemas según tu stack. La meta es reducir carga manual y mejorar la trazabilidad entre ventas, inventario y despacho.",
  },
  {
    q: "¿Cómo se calculan las tarifas?",
    a: "Dependen de volumen, espacio usado, tipo de producto, operaciones de picking/packing, empaques y destinos de envío. Te presentamos una propuesta según tu caso real.",
  },
  {
    q: "¿Qué ciudades cubren?",
    a: "Operamos última milla en Bogotá, Cali y Medellín, y coordinamos distribución nacional con aliados según cobertura, tiempos y nivel de servicio acordado.",
  },
  {
    q: "¿Ayudan a marcas internacionales?",
    a: "Sí. Podemos operar inventario, fulfillment y distribución local para compañías que quieren vender en Colombia sin montar infraestructura propia desde el día uno.",
  },
];

export const FAQ_PAGE_ITEMS = [
  {
    q: "¿Qué incluye el servicio de fulfillment?",
    a: "Incluye recepción de inventario, almacenamiento, control por SKU, preparación de pedidos, empaque, despacho, trazabilidad y manejo de devoluciones cuando el flujo lo requiere.",
  },
  {
    q: "¿Qué tipo de empresas pueden trabajar con Shipply?",
    a: "Trabajamos con marcas de e-commerce, negocios B2B, distribuidores y compañías internacionales que venden productos físicos en Colombia. Validamos restricciones de producto antes de iniciar.",
  },
  {
    q: "¿Existe un mínimo de pedidos mensuales?",
    a: "No usamos una regla única para todos los casos. Revisamos la operación, complejidad del catálogo y proyección de crecimiento para confirmar si el modelo tiene sentido comercial y operativo.",
  },
  {
    q: "¿Cómo se gestiona el inventario?",
    a: "El inventario se administra por SKU con entradas, salidas y movimientos registrados. Durante onboarding definimos carga de catálogo, reglas de almacenamiento y responsables de actualización.",
  },
  {
    q: "¿Qué información puedo consultar sobre mis pedidos?",
    a: "Puedes dar seguimiento a estados operativos como recepción, preparación, despacho, novedades y entrega, según el alcance acordado y las integraciones activas.",
  },
  {
    q: "¿Qué pasa si un pedido se devuelve?",
    a: "Definimos un flujo de devoluciones con recepción, registro, revisión y disposición de producto según tu política comercial y condición de la mercancía.",
  },
  {
    q: "¿Pueden personalizar empaques o procesos?",
    a: "Sí, cuando el volumen y el flujo lo justifican. Podemos revisar empaques, etiquetado, controles de calidad y reglas especiales de preparación.",
  },
  {
    q: "¿Cuánto tarda el onboarding?",
    a: "Depende de catálogo, integraciones, recepción de inventario y reglas de operación. Después del diagnóstico te damos un cronograma realista para iniciar.",
  },
];

export const INTERNATIONAL_FAQS = [
  {
    q: "Do we need a Colombian company to start?",
    a: "Not necessarily. Shipply can act as the local operating layer for receiving, warehousing, fulfillment, delivery, and local billing support, depending on the commercial structure agreed for your program.",
  },
  {
    q: "Which countries can ship inventory into your operation?",
    a: "We can scope inbound flows from China, Europe, North America, and other origins. During onboarding we review origin lanes, SKU data, documentation, and timing.",
  },
  {
    q: "Can you connect with Shopify or marketplaces?",
    a: "Yes. We review your stack and sales channels first, then define the integration or operational workflow that gives the right level of visibility without overcomplicating launch.",
  },
  {
    q: "What does pricing depend on?",
    a: "Pricing depends on storage needs, order volume, SKU complexity, packaging, returns, city coverage, and delivery service levels. We quote after reviewing the operating model.",
  },
];
